import { render } from "./floating_chat_widget.html?vue&type=template&id=2affbcb7&external"
import script from "./floating_chat_widget.js?vue&type=script&lang=js&external"
export * from "./floating_chat_widget.js?vue&type=script&lang=js&external"

import "./floating_chat_widget.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__